import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  uid: string;
  label: string;
  error: Error | null;
}


import { ref, computed, onMounted, defineComponent } from 'vue';

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    HostedField: ComponentWithProps<Props>;
  }
}

const __default__ = defineComponent({ name: 'HostedField' });

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    uid: null,
    label: null,
    error: null
  },
  emits: ['mounted'],
  setup(__props: any, { expose, emit }) {

const props = __props as {
  uid: string;
  label: string;
  error: Error | null;
};

/**
 * `HostedField` component properties.
 */




const focused = ref(false);
const showError = ref(false);

/** ... */
const occupied = computed(() => focused.value);

const classList = computed(() => {
  const items = ['form-field', 'form-field-hosted'];

  if (occupied.value) {
    items.push('occupied');
  }

  if (props.error) {
    items.push('error');
  }

  return items;
});

onMounted(() => emit('mounted'));

expose({ showError });

return { __sfc: true,props, emit, focused, showError, occupied, classList }
}

})